import { Circle as CircleStyle, Fill, Icon, Stroke, Style, Text } from "ol/style";
import { Feature } from "ol";
// import { Polygon as OLPolygon } from "ol/geom";
import { fromExtent } from "ol/geom/Polygon";
import { getMap } from "../Providers/mapProvider";
import GeoJSON from "ol/format/GeoJSON";
import bboxClip from "@turf/bbox-clip";
import { BBox, polygon } from "@turf/helpers";
import difference from "@turf/difference";
import clone from "@turf/clone";
import intersect from "@turf/intersect";

const fill = new Fill({
    color: "#dd5e47"
});
const stroke = new Stroke({
    color: "white",
    width: 1.5
});

const clusterCache = new Map<number, Style>();

const ensureClusterSymbol = (count: number): void => {
    if (!clusterCache.has(count)) {
        clusterCache.set(
            count,
            new Style({
                image: new Icon({
                    src: createImage(18, count, "#84BD01"),
                    imgSize: [36, 36]
                })
            })
        );
    }
};

const createImage = function (radius, count, textColor) {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    canvas.width = radius * 2;
    canvas.height = radius * 2;

    // border
    ctx.beginPath();
    ctx.arc(radius, radius, 18, 0, 2 * Math.PI);
    ctx.fillStyle = "rgba(255, 255, 255, 0.5)";
    ctx.fill();

    // circle
    ctx.beginPath();
    ctx.arc(radius, radius, 18 - 3, 0, 2 * Math.PI);
    ctx.fillStyle = "#dd5e47";
    ctx.fill();

    // text
    ctx.beginPath();
    ctx.font = "bold 14px sans-serif";
    ctx.fillStyle = "#ffffff";
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.fillText(count, radius, radius);

    return canvas.toDataURL();
};

export const getClusterSymbol = (count: number): Style => {
    ensureClusterSymbol(count);
    return clusterCache.get(count);
};

export const getSimpleSymbol = (isVisible: boolean, radius?: number): Style => {
    return isVisible
        ? new Style({
              image: new CircleStyle({
                  fill: fill,
                  stroke: stroke,
                  radius: radius || 7
              }),
              fill: fill,
              stroke: stroke
          })
        : new Style({});
};

const windFarmLabel = new Style({
    text: new Text({
        font: "bold 12px Helvetica, sans-serif",
        fill: new Fill({
            color: [203, 99, 255, 1]
        }),
        stroke: new Stroke({
            color: "#fff",
            width: 4
        })
        // overflow: true
    })
});

const windFarmStyle = new Style({
    fill: new Fill({
        color: [203, 99, 255, 0.6]
    })
});

const format = new GeoJSON();

export const getPolygonSymbol = (feature: Feature, strokeWidth?: number): Style => {
    let style;
    if (feature.get("LAYERID") === "1") {
        //************************************************* */
        //*******   another implementation   ************** */
        //************************************************* */
        const bbox = getMap().getView().calculateExtent();
        const turfFeature = format.writeFeatureObject(feature);
        const clipped = bboxClip(turfFeature, bbox as BBox);
        const coordinates = clipped.geometry.coordinates;
        for (let i = coordinates.length - 1; i >= 0; i--) {
            if (coordinates[i].length === 0) {
                coordinates.splice(i, 1);
            }
        }
        const geometry = format.readFeature(clipped).getGeometry();
        windFarmLabel.setGeometry(geometry);
        windFarmLabel.getText().setText(feature.get("NAME"));

        //*************************************************************** */
        //*******   my implementation, not working anymore,  ************** */
        //*******   because of curved lines in polygons      ************** */
        //*************************************************************** */
        // const map = getMap();
        // const mapSize = map.getSize();
        // const mapExtent = map.getView().calculateExtent([mapSize[0], mapSize[1]]);

        // const geometry = feature.getGeometry() as Polygon;
        // const extGeometry = fromExtent(mapExtent);

        // const featurePolygon = polygon(geometry.getCoordinates());
        // const extentPolygon = polygon(extGeometry.getCoordinates());

        // const differenceGeom = difference(clone(extentPolygon), clone(featurePolygon));

        // if (differenceGeom) {
        //     const intersection = intersect(featurePolygon, extentPolygon);
        //     const newGeom = intersection && format.readGeometry(intersection.geometry);
        //     newGeom && windFarmLabel.setGeometry(newGeom);
        // } else {
        //     windFarmLabel.setGeometry(geometry);
        // }
        // windFarmLabel.getText().setText(feature.get("NAME"));

        style = [windFarmStyle, windFarmLabel];
    } else {
        style = new Style({
            stroke: new Stroke({
                color: [221, 92, 70, 1],
                width: strokeWidth || 3
            }),
            fill: new Fill({
                color: [221, 92, 70, 0.5]
            })
        });
    }
    return style;
};
